<template>
  <div>
    <notifications-wrapper />
    <nuxt />
    <custom-footer />
  </div>
</template>
<script>
import CustomFooter from '@/components/commons/CustomFooter.vue'
import NotificationsWrapper from '@/components/commons/NotificationsWrapper.vue'

export default {
  components: {
    CustomFooter,
    NotificationsWrapper
  }
}
</script>
